import { useSearchResultCardContext } from './SearchResultCardProvider';
import { FavoriteButton } from '../FavoriteButton/FavoriteButton';

import styles from './SearchResultCardImage.module.css';

export const SearchResultCardFavoriteButton = () => {
  const { isInWatchlist, listing, onWatchlistClick, translationResolver } = useSearchResultCardContext();

  if (!onWatchlistClick) return null;

  return (
    <FavoriteButton
      className={styles.favoriteButton}
      listing={listing}
      variant="filled"
      isInWatchlist={isInWatchlist}
      onWatchlistClick={onWatchlistClick}
      translationResolver={translationResolver}
      data-testid="search-components_result-card_favourite-button"
    />
  );
};
